import React, { useState } from 'react';
import { FormModal } from 'newComponents/Modal';
import { Button } from 'components/Button';
import { Content, Message, Footer } from './styled';

export interface UpdateModalProps {
  /** Confirma a atualização: limpa o cache local (mantendo o login) e recarrega. */
  onConfirm: () => void;
  /** Adia a atualização: fecha a modal; o VersionChecker re-lembra no próximo load. */
  onDismiss: () => void;
}

/**
 * Aviso adiável de nova versão. Casca visual reaproveita o FormModal de newComponents.
 * É presentational: quem decide o que "confirmar"/"adiar" fazem é o VersionChecker.
 */
const UpdateModal: React.FC<UpdateModalProps> = ({ onConfirm, onDismiss }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleConfirm = () => {
    // Evita duplo clique antes do reload disparado por onConfirm.
    if (isUpdating) return;
    setIsUpdating(true);
    onConfirm();
  };

  return (
    <FormModal title="Nova versão disponível" setClose={() => onDismiss()}>
      <Content>
        <Message>
          Uma nova versão do Leankeep está disponível. Atualize agora para acessar as melhorias e correções mais
          recentes. <br />
          <b>Não se preocupe: seus dados de login serão mantidos.</b>
        </Message>
      </Content>
      <Footer>
        <Button theme="outline" onClick={onDismiss} disabled={isUpdating}>
          Depois
        </Button>
        <Button theme="primary" onClick={handleConfirm} disabled={isUpdating}>
          {isUpdating ? 'Atualizando…' : 'Atualizar agora'}
        </Button>
      </Footer>
    </FormModal>
  );
};

export default UpdateModal;
